import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2IssueStatusHistory } from '@/api/model/interfaces';

export default class PackageKS2IssueStatusHistoryOdata extends OdataManager<PackageKS2IssueStatusHistory> {}
